module.exports = __webpack_public_path__ + "static/media/stepComplete.792100c6.png";